import { cn } from "./utils/cn";

/**
 * Spinner — a simple indeterminate spinner. role="status" for screen readers.
 */
export function Spinner({ size = "md", className }: { size?: "sm" | "md" | "lg"; className?: string }) {
  const px = size === "sm" ? 14 : size === "lg" ? 28 : 18;
  return (
    <span role="status" aria-label="Loading" className={cn("inline-block", className)}>
      <svg width={px} height={px} viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" strokeOpacity="0.2" fill="none" />
        <path
          d="M21 12a9 9 0 0 1-9 9"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        >
          <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.9s" repeatCount="indefinite" />
        </path>
      </svg>
    </span>
  );
}
